import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/smart/library/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'Smart Library',
    meta: {
      title: 'smartLibrary.sideMenu.title',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.library,
      icon: 'local_library',
    },
    children: [
      {
        path: MODULE_PATH + 'list',
        component: load('application/smart-library/components/SmartLibraryList'),
        name: 'Smart Library List',
        meta: {
          title: 'smartLibrary.smartLibraryList.title',
          icon: 'attach_money',
          menuItem: true,
          sorting: 3001,
        },
      },
      {
        path: MODULE_PATH + 'create',
        component: load('application/smart-library/components/forms/createUpdateSmartLibraryForm'),
        name: 'New Smart Library',
        meta: {
          title: 'smartLibrary.newSmartLibrary.title',
          icon: 'attach_money',
          menuItem: false,
          sorting: 3001,
        },
      },
      {
        path: MODULE_PATH + '[:smartLibraryId]/update',
        component: load('application/smart-library/components/forms/createUpdateSmartLibraryForm'),
        name: 'Update Smart Library',
        props: true,
        meta: {
          title: 'smartLibrary.updateSmartLibrary.title',
          icon: 'attach_money',
          menuItem: false,
          sorting: 3001,
        },
      },
      {
        path: MODULE_PATH + 'eform/list',
        component: load('application/smart-library/components/EFormList'),
        name: 'e-Form List',
        meta: {
          title: 'smartLibrary.eFormList.title',
          icon: 'attach_money',
          menuItem: true,
          sorting: 3002,
        },
      },
      {
        path: MODULE_PATH + 'eform/create',
        component: load('application/smart-library/components/forms/createUpdateSmartLibraryEForm'),
        name: 'New e-Form',
        meta: {
          title: 'smartLibrary.newEForm.title',
          icon: 'attach_money',
          menuItem: false,
          sorting: 3003,
        },
      },
      {
        path: MODULE_PATH + 'eform/[:eFormId]/update',
        component: load('application/smart-library/components/forms/createUpdateSmartLibraryEForm'),
        name: 'Update e-Form',
        props: true,
        meta: {
          title: 'smartLibrary.updateEForm.title',
          icon: 'attach_money',
          menuItem: false,
          sorting: 3004,
        },
      },
    ],
  },
]
